
import { Component, inject, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { CardGridComponent, CardSliderComponent, DeviceService, DeviceType, ICard } from '@sirius/common';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'ur-item-slider-or-grid-view',
    templateUrl: './item-slider-or-grid-view.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CardGridComponent, CardSliderComponent]
})
export class ItemSliderOrGridViewComponent {
    deviceService: DeviceService = inject(DeviceService);

    //This value is decided by UX
    MINIMUM_SLIDER_ITEMS = 3;

    title = input<string>('');
    description = input<string | null>('');
    items = input.required<ICard[]>();

    isDesktop: Signal<DeviceType | undefined> = toSignal(this.deviceService.deviceType$);
}
